import React from "react";
import useVirtualTableOfContents from "./use-virtual-table-of-contents";
import PublicationComponentType from "utilities/enumerations/publication-component-type";
import PublicationMetadataTypeEnum from "models/interfaces/publication-metadata-types";
import MetadataContent from "organisms/publication-content/metadata-content";
import AnnexContentWithinPanel from "organisms/publication-content/notebook-reference-panel/annex-content-within-panel";
import ChapterContentWithinPanel from "organisms/publication-content/notebook-reference-panel/chapter-content-within-panel";
import AnnexGroupContentWithinPanel from "organisms/publication-content/notebook-reference-panel/annex-group-content-within-panel";
import useCurrentPublication from "utilities/contexts/use-current-publication";
import PublicationTypes from "constants/publication-types";
import ArticleContentWithinPanel from "organisms/publication-content/notebook-reference-panel/article-content-within-panel";

const NotebookBookviewDisplay = () => {
    const { currentTocItem } = useVirtualTableOfContents();
    const { publication } = useCurrentPublication();

    const isNECStyle = () => {
        return (
            publication.type === PublicationTypes.NEC &&
            currentTocItem?.nfpaLabel !== "9"
        );
    };

    switch (currentTocItem?.publicationType) {
        case PublicationMetadataTypeEnum.COMMITTEES:
        case PublicationMetadataTypeEnum.TRANSLATIONS:
        case PublicationMetadataTypeEnum.ORIGINS:
            return <MetadataContent />;
        case PublicationComponentType.Chapter:
            return <ChapterContentWithinPanel />;
        case PublicationComponentType.Article:
        case PublicationComponentType.Section:
            return isNECStyle() ? (
                <ArticleContentWithinPanel />
            ) : (
                <ChapterContentWithinPanel />
            );
        case PublicationComponentType.Annex:
            return <AnnexContentWithinPanel />;
        case PublicationComponentType.AnnexGroup:
            return <AnnexGroupContentWithinPanel />;
        default:
            return <div>Unsupported publication type</div>;
    }
};

export default NotebookBookviewDisplay;
